import React, { useEffect, useMemo, useRef, useState, } from 'react';
import { ActivityIndicator, Dimensions, Image, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ProgressIndicatorTypeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import LottieView from 'lottie-react-native';
import { isMobile } from '../../stack/utils';
import { ProgressIndicator } from "../../progressIndicator/ProgressIndicator";
import { Button } from "../../button/Button";
import { OtpInput } from "../OtpInput/OtpInput";
import { Space } from "../../space/Space";
import { Header } from "../../header/Header";
import { addCommasToNumber } from "../utils";
const PledgePorfolio = ({ bankData, profileAction, stepperData, triggerAction, backAction, applyAction, modalState, continuePress, userName, height, creditLimit, sanctionedAmount, isPendingForeclosure, loading, showIncreaseLimit, showCamsLoader, bankCode, bankName, showCamsOtp, showKarvyLoader, showKarvyOtp, pledgingOrder, showCamsFetchSuccess, counter, showKarvyPledgeSuccess, addBankAction, kFinCounter, showCamsPledgeSuccesss, CamsCounter, successAmount, skipBankAction, error, errorCounter, identifier, otpChannel, noOfDigits, isError = false, isEnhancedLimit, fetchKarvyAction, currentAssetRepository }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const inputRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [successLottie, setSuccessLottie] = useState('');
    const [seconds, setSeconds] = useState(30);
    const [isRunning, setIsRunning] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [showCamsFetchLoader, setShowCamsFetchLoader] = useState(false);
    const [showKarvyPledgeLoader, setShowKarvyPledgeLoader] = useState(false);
    const [showCamsPledgeLoader, setShowCamsPledgeLoader] = useState(false);
    const [unlockAmount, setUnlockedAmount] = useState(0);
    const [updatedPledgingOrder, setUpdatedPledgingOrder] = useState(new Map);
    const [showCamsPledge, setShowCamsPledge] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [completionPercentage, setCompletionPercentage] = useState(sanctionedAmount);
    const [showCamsLoaderState, setShowCamesLoaderState] = useState(false);
    const [showCamsOtpState, setShowCamsOtpState] = useState(false);
    const [showCamsFetchSuccessState, setShowCamsFetchSuccess] = useState(false);
    const [showCamsPledgeSuccessState, setShowCamsPledgeSuccess] = useState(false);
    const [showKarvyLoaderState, setShowKarvyLoaderState] = useState(false);
    const [kfinLottie, setKfinLottie] = useState("");
    const [showKarvyPledgeSuccessState, setShowKarvyPledgeSuccess] = useState(false);
    const [showKarvyModal, setShowKarvyModal] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme?.colors;
    const mobHeight = Dimensions.get('window').height;
    const [showLoadingLottie, setShowLoadingLottie] = useState("");
    const [_isError, setIsError] = useState(false);
    const [resendOTPClicked, setResendOTPClicked] = useState(false);
    const elementAtZeroPosition = Object.keys(pledgingOrder).find(key => pledgingOrder[key] === 0) || 'No element is at position 0';
    const getPriority = (key) => {
        return pledgingOrder[key] !== undefined ? pledgingOrder[key] : Number.MAX_SAFE_INTEGER;
    };
    const camsPledgePriority = getPriority("CAMS_PLEDGE");
    const kfinPledgePriority = getPriority("KFIN_PLEDGE");
    const isCamsPledgeHigherPriority = camsPledgePriority < kfinPledgePriority;
    const DELAY = 1000;
    useEffect(() => {
        setIsErrorState(error);
    }, [error, errorCounter]);
    useEffect(() => {
        if (isErrorState &&
            isErrorState === true) {
            setShowCamsFetchLoader(false);
            setShowKarvyPledgeLoader(false);
            setShowCamsPledgeLoader(false);
        }
    }, [isErrorState]);
    useEffect(() => {
        setIsError(isError);
    }, [isError]);
    useEffect(() => {
        if (resendOTPClicked) {
            setTimeout(() => {
                setResendOTPClicked(false);
            }, 3000);
        }
    }, [resendOTPClicked]);
    useEffect(() => {
        if (isError) {
            setShowModal(false);
            setShowCamesLoaderState(false);
            setShowKarvyModal(false);
            setShowKarvyLoaderState(false);
            setShowCamsPledge(false);
            setShowCamesLoaderState(false);
        }
    }, [_isError]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        setShowCamsFetchSuccess(showCamsFetchSuccess);
    }, [showCamsFetchSuccess, counter]);
    useEffect(() => {
        setShowKarvyPledgeSuccess(showKarvyPledgeSuccess);
        setUnlockedAmount(successAmount);
    }, [showKarvyPledgeSuccess, kFinCounter, successAmount]);
    useEffect(() => {
        setShowCamsPledgeSuccess(showCamsPledgeSuccesss);
    }, [showCamsPledgeSuccesss, CamsCounter]);
    useEffect(() => {
        setUpdatedPledgingOrder(pledgingOrder);
    }, [pledgingOrder, counter]);
    useEffect(() => {
        if (pledgingOrder.hasOwnProperty("CAMS_FETCH")) {
            setShowCamesLoaderState(true);
        }
        else {
            if (pledgingOrder.hasOwnProperty("KFIN_PLEDGE")) {
                setShowKarvyLoaderState(true);
            }
        }
        fetch("https://lottie.host/07df683d-9f8f-409b-8573-cf62029c3d36/FDlfEbnATZ.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setKfinLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch("https://lottie.host/2d6208fa-af15-47e6-a728-f53bceae133a/AzCK56GYem.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setShowLoadingLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch('https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: 'bt_pledgePortfolio_goBack', type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: 'Pledge portfolio', onPress: () => {
                if (skipBankAction) {
                    triggerAction(skipBankAction);
                }
            } }));
    }, []);
    const renderInfoBoxCams = () => {
        return (React.createElement(View, { style: { alignItems: "center", paddingVertical: 24 } },
            React.createElement(View, null,
                React.createElement(Typography, { label: elementAtZeroPosition === 'KFIN_FETCH'
                        ? "Authenticating your portfolio via KFIN"
                        : "Authenticating your portfolio via CAMS", textAlign: TextAlignTokens.center, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 32 } }),
            elementAtZeroPosition === 'CAMS_FETCH' && Platform.OS !== "ios" &&
                React.createElement(LottieView, { source: showLoadingLottie, style: { width: 273, height: 378 }, autoPlay: true, loop: true }),
            elementAtZeroPosition === 'CAMS_FETCH' && Platform.OS === "ios" && React.createElement(LottieView, { source: { uri: "https://lottie.host/2d6208fa-af15-47e6-a728-f53bceae133a/AzCK56GYem.json" }, style: { width: 273, height: 378 }, autoPlay: true, loop: true }),
            elementAtZeroPosition === 'KFIN_FETCH' && Platform.OS !== "ios" &&
                React.createElement(LottieView, { source: kfinLottie, style: { width: 273, height: 378 }, autoPlay: true, loop: true }),
            elementAtZeroPosition === 'KFIN_FETCH' && Platform.OS === "ios" && React.createElement(LottieView, { source: { uri: "https://lottie.host/07df683d-9f8f-409b-8573-cf62029c3d36/FDlfEbnATZ.json" }, style: { width: 273, height: 378 }, autoPlay: true, loop: true })));
    };
    const renderInfoBoxCamsPledge = () => {
        return (React.createElement(View, { style: { alignItems: "center", paddingVertical: 24 } },
            React.createElement(View, null,
                React.createElement(Typography, { label: "Pledging your portfolio with CAMS", textAlign: TextAlignTokens.center, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 32 } }),
            Platform.OS !== "ios" &&
                React.createElement(LottieView, { source: showLoadingLottie, style: { width: 273, height: 378 }, autoPlay: true, loop: true }),
            Platform.OS === "ios" && React.createElement(LottieView, { source: { uri: "https://lottie.host/2d6208fa-af15-47e6-a728-f53bceae133a/AzCK56GYem.json" }, style: { width: 273, height: 378 }, autoPlay: true, loop: true })));
    };
    const renderInfoBoxKarvy = () => {
        return (React.createElement(View, { style: { alignItems: "center", paddingVertical: 24 } },
            React.createElement(View, null,
                React.createElement(Typography, { label: "Pledging your portfolio with KFintech", textAlign: TextAlignTokens.center, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 32 } }),
            Platform.OS !== "ios" &&
                React.createElement(LottieView, { source: kfinLottie, style: { width: 273, height: 378 }, autoPlay: true, loop: true }),
            Platform.OS === "ios" && React.createElement(LottieView, { source: { uri: "https://lottie.host/07df683d-9f8f-409b-8573-cf62029c3d36/FDlfEbnATZ.json" }, style: { width: 273, height: 378 }, autoPlay: true, loop: true })));
    };
    const returnOtpModalCAMSPledge = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16 }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    paddingHorizontal: 8,
                    paddingVertical: 8,
                    // backgroundColor: '#E7F4ED',
                    backgroundColor: colorMapping[ColorTokens.Secondary_05],
                    width: 107,
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 8
                } },
                React.createElement(View, { style: { ...Platform.OS !== "web" && { marginLeft: 8 } } },
                    React.createElement(Icon, { name: otpChannel === "SMS" ? IconTokens.CheckSms : IconTokens.MailIcon, size: IconSizeTokens.LG, color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: {
                        marginLeft: 8, ...Platform.OS !== "web" && {
                            marginRight: 8
                        }
                    } },
                    React.createElement(Typography, { label: otpChannel === "SMS" ? 'Check SMS' : 'Check email', fontWeight: '500', fontSize: FontSizeTokens.XS, color: ColorTokens.Secondary_100, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(View, { style: { marginTop: 20 } }),
            React.createElement(Typography, { label: `Enter OTP`, fontWeight: '700', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Typography, { label: `An OTP was sent on ${identifier}`, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(OtpInput, { numberOfDigits: noOfDigits, ref: inputRef, editable: !showCamsPledgeLoader, onTextChange: (text) => {
                        if (text.length === 5) {
                            if (addBankAction) {
                                setShowCamsPledgeLoader(true);
                                setIsErrorState(false);
                                handleReset();
                                setShowTimer(false);
                                triggerAction({
                                    ...addBankAction,
                                    payload: {
                                        otp: text,
                                        value: "CAMS_PLEDGE"
                                    },
                                });
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setShowCamsPledgeLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8 },
                        pinCodeTextStyle: { fontSize: 15 },
                        containerStyle: { width: 300 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                showCamsPledgeLoader && !isErrorState && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                isErrorState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: userName }))),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        paddingTop: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            if (seconds === 0) {
                                setShowTimer(false);
                                //@ts-ignore
                                inputRef?.current?.clear();
                                setIsErrorState(false);
                                handleReset();
                                setShowCamsPledgeLoader(false);
                                setResendOTPClicked(true);
                                if (profileAction) {
                                    triggerAction({
                                        ...profileAction,
                                        payload: {
                                            value: "CAMS_PLEDGE",
                                        },
                                    });
                                }
                            }
                            else {
                                setShowTimer(true);
                            }
                        } },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                showTimer && seconds > 0 && !resendOTPClicked && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `You can resend in ${seconds} ${seconds === 1 ? 'sec' : 'secs'}`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))),
                resendOTPClicked &&
                    React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "OTP sent successfully", color: ColorTokens.Secondary_100, textAlign: TextAlignTokens.left })))));
    };
    const returnOtpModalCAMS = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16 }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    paddingHorizontal: 6,
                    paddingVertical: 8,
                    backgroundColor: colorMapping[ColorTokens.Secondary_05],
                    width: 107,
                    flexDirection: 'row',
                    borderRadius: 8
                } },
                React.createElement(Icon, { name: otpChannel === "SMS" ? IconTokens.CheckSms : IconTokens.MailIcon, size: IconSizeTokens.LG, color: ColorTokens.Primary_100 }),
                React.createElement(View, { style: {
                        marginLeft: 8, ...Platform.OS !== "web" && {
                            marginRight: 8
                        }
                    } },
                    React.createElement(Typography, { label: otpChannel === "SMS" ? 'Check SMS' : 'Check email', fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(View, { style: { marginTop: 20 } }),
            React.createElement(Typography, { label: `Enter OTP`, fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night, lineHeight: 24, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Typography, { label: `An OTP was sent on ${identifier}`, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(OtpInput, { numberOfDigits: noOfDigits, ref: inputRef, editable: !showCamsFetchLoader, onTextChange: async (text) => {
                        if (text.length === noOfDigits) {
                            setShowCamsFetchLoader(true);
                            setIsErrorState(false);
                            handleReset();
                            setShowTimer(false);
                            if (applyAction) {
                                await triggerAction({
                                    ...applyAction,
                                    payload: {
                                        value: text,
                                        assetRepositoryType: elementAtZeroPosition === 'KFIN_FETCH' ? 'KARVY' : 'CAMS'
                                    },
                                });
                            }
                            await setTimeout(() => {
                                setShowCamsFetchLoader(false);
                            }, DELAY);
                        }
                        else {
                            setIsErrorState(false);
                            setShowCamsFetchLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8 },
                        pinCodeTextStyle: { fontSize: 15 },
                        containerStyle: { width: 300 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                showCamsFetchLoader && !isErrorState && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                isErrorState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: userName }))),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        paddingTop: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            setShowTimer(true);
                            if (seconds === 0) {
                                handleReset();
                                setShowCamsFetchLoader(false);
                                //@ts-ignore
                                inputRef?.current?.clear();
                                setIsErrorState(false);
                                if (elementAtZeroPosition === 'KFIN_FETCH') {
                                    triggerAction(fetchKarvyAction);
                                }
                                else {
                                    triggerAction(continuePress);
                                }
                            }
                        } },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `You can resend in ${seconds} ${seconds === 1 ? 'sec' : 'secs'}`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))))));
    };
    const handleReset = () => {
        setSeconds(30);
        setIsRunning(true);
    };
    const returnOtpModalKarvy = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16 }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    paddingHorizontal: 8,
                    paddingVertical: 8,
                    backgroundColor: colorMapping[ColorTokens.Secondary_05],
                    width: 107,
                    flexDirection: 'row',
                    alignContent: 'center',
                    justifyContent: 'center',
                    borderRadius: 6
                } },
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Icon, { name: IconTokens.CheckSms, size: IconSizeTokens.LG, color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: Platform.OS !== "web" ? {
                        marginLeft: 8,
                        marginRight: 8
                    } : { marginLeft: 8 } },
                    React.createElement(Typography, { label: 'Check SMS', fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Secondary_100, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(View, { style: { marginTop: 20 } }),
            React.createElement(Typography, { label: `KFintech has sent an OTP`, fontWeight: '700', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Typography, { label: `An OTP was sent on ${identifier}`, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(OtpInput, { id: 'tf_pledgePortfolio_otp', numberOfDigits: noOfDigits, ref: inputRef, editable: !showKarvyPledgeLoader, onTextChange: (text) => {
                        if (text.length === 6) {
                            if (addBankAction) {
                                handleReset();
                                setShowTimer(false);
                                setShowKarvyPledgeLoader(true);
                                setIsErrorState(false);
                                triggerAction({
                                    ...addBankAction,
                                    payload: {
                                        otp: text,
                                        value: "KFIN_PLEDGE"
                                    },
                                });
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setShowKarvyPledgeLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8 },
                        pinCodeTextStyle: { fontSize: 15 },
                        containerStyle: { width: 300 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                showKarvyPledgeLoader && !isErrorState && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                isErrorState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: userName }))),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        paddingTop: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            if (seconds === 0) {
                                setShowTimer(false);
                                //@ts-ignore
                                inputRef?.current?.clear();
                                setIsErrorState(false);
                                handleReset();
                                setShowKarvyPledgeLoader(false);
                                setResendOTPClicked(true);
                                if (profileAction) {
                                    triggerAction({
                                        ...profileAction,
                                        payload: {
                                            value: "KFIN_PLEDGE",
                                        },
                                    });
                                }
                            }
                            else {
                                setShowTimer(true);
                            }
                        } },
                        React.createElement(Typography, { id: 'txt_pledgePortfolio_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                showTimer && seconds > 0 && !resendOTPClicked && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `You can resend in ${seconds} ${seconds === 1 ? 'sec' : 'secs'}`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))),
                resendOTPClicked &&
                    React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "OTP sent successfully", color: ColorTokens.Secondary_100, textAlign: TextAlignTokens.left })))));
    };
    const modalContentPresenter = () => {
        return showCamsFetchSuccessState ? renderVerificationSuccess() : showCamsLoaderState ? renderInfoBoxCams() : returnOtpModalCAMS();
    };
    const modalContentPresenterKarvyPledge = () => {
        return showKarvyPledgeSuccessState ? renderVerificationSuccessKarvy() : showKarvyLoaderState ? renderInfoBoxKarvy() : returnOtpModalKarvy();
    };
    const modalContentPresenterCamsPledge = () => {
        return showCamsPledgeSuccessState ? renderVerificationSuccessCAMS() : showCamsLoaderState ? renderInfoBoxCamsPledge() : returnOtpModalCAMSPledge();
    };
    const renderVerificationSuccessKarvy = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                alignItems: 'center',
                flex: 1,
            } },
            successLottie && React.createElement(LottieView, { source: Platform.OS === "ios" ? { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" } : successLottie, style: {
                    width: 80, height: 80,
                    ...Platform.OS !== "web" && {
                        marginTop: 8
                    }
                }, autoPlay: true, loop: true }),
            React.createElement(View, { style: {
                    marginTop: 24,
                    flexDirection: 'row',
                    alignContent: 'center',
                } },
                React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, fontWeight: '600', color: ColorTokens.Grey_Night, lineHeight: 24 }),
                React.createElement(View, { style: { marginTop: 1 } },
                    React.createElement(Typography, { label: `${addCommasToNumber(unlockAmount)} unlocked successfully`, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 }))),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    marginBottom: 10,
                    paddingBottom: 12,
                    marginTop: 16
                } },
                React.createElement(Button, { id: 'bt_pledgePortFolio_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: async () => {
                        if (!isCamsPledgeHigherPriority && pledgingOrder.hasOwnProperty("CAMS_PLEDGE")) {
                            setShowKarvyModal(false);
                            setShowCamsPledge(true);
                            setShowCamesLoaderState(true);
                            if (profileAction) {
                                await triggerAction({
                                    ...profileAction,
                                    payload: {
                                        value: "CAMS_PLEDGE",
                                    },
                                });
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowCamesLoaderState(false);
                                }, DELAY);
                        }
                        else {
                            if (backAction) {
                                await triggerAction(backAction);
                            }
                        }
                    } }))));
    };
    const renderVerificationSuccessCAMS = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                alignItems: 'center',
                flex: 1,
            } },
            successLottie && React.createElement(LottieView, { source: Platform.OS === "ios" ? { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" } : successLottie, style: {
                    width: 80, height: 80,
                    ...Platform.OS !== "web" && {
                        marginTop: 8
                    }
                }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { label: `₹${addCommasToNumber(unlockAmount)} unlocked successfully`, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: isCamsPledgeHigherPriority && pledgingOrder.hasOwnProperty("KFIN_PLEDGE") ? 'Continue to mark KFIN funds' : 'Please proceed to the next step', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    marginBottom: 10,
                    paddingBottom: 12,
                    marginTop: Platform.OS !== "web" ? 24 : 16
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: isCamsPledgeHigherPriority && pledgingOrder.hasOwnProperty("KFIN_PLEDGE") ? 'Continue' : 'Continue', width: ButtonWidthTypeToken.FULL, onPress: async () => {
                        if (isCamsPledgeHigherPriority && pledgingOrder.hasOwnProperty("KFIN_PLEDGE")) {
                            setShowCamesLoaderState(false);
                            setShowKarvyModal(true);
                            setShowKarvyLoaderState(true);
                            setShowCamsPledge(false);
                            if (profileAction) {
                                await triggerAction({
                                    ...profileAction,
                                    payload: {
                                        value: "KFIN_PLEDGE",
                                    },
                                });
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowKarvyLoaderState(false);
                                }, DELAY);
                        }
                        else {
                            if (backAction) {
                                await triggerAction(backAction);
                            }
                        }
                    } }))));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                alignItems: 'center',
                flex: 1,
            } },
            successLottie && React.createElement(LottieView, { source: Platform.OS === "ios" ? { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" } : successLottie, style: {
                    width: 80, height: 80,
                    ...Platform.OS !== "web" && {
                        marginTop: 8
                    }
                }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { label: `${currentAssetRepository} verified successfully`, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Please continue to mark your portfolio', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    marginBottom: 10,
                    paddingBottom: 12,
                    marginTop: Platform.OS !== "web" ? 24 : 16
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: (elementAtZeroPosition === 'KFIN_FETCH' || elementAtZeroPosition === 'KFIN_PLEDGE') ? 'Continue to mark KFIN funds' : 'Continue to mark CAMS funds', width: ButtonWidthTypeToken.FULL, onPress: async () => {
                        setShowModal(false);
                        await checkUpdatedPledgingOrder();
                    } }))));
    };
    const checkUpdatedPledgingOrder = async () => {
        if (elementAtZeroPosition === "KFIN_FETCH") {
            setShowModal(true);
            setShowCamsFetchSuccess(false);
            setShowCamesLoaderState(true);
            if (triggerAction) {
                await triggerAction(fetchKarvyAction);
            }
            !_isError &&
                setTimeout(() => {
                    setShowCamsFetchSuccess(false);
                    setShowCamesLoaderState(false);
                }, DELAY);
        }
        else if (elementAtZeroPosition === "KFIN_PLEDGE") {
            setShowKarvyModal(true);
            setShowKarvyLoaderState(true);
            if (profileAction) {
                await triggerAction({
                    ...profileAction,
                    payload: {
                        value: "KFIN_PLEDGE",
                    },
                });
            }
            !_isError &&
                setTimeout(() => {
                    setShowKarvyLoaderState(false);
                }, DELAY);
        }
        else {
            setShowCamsPledge(true);
            setShowCamesLoaderState(true);
            if (profileAction) {
                await triggerAction({
                    ...profileAction,
                    payload: {
                        value: "CAMS_PLEDGE",
                    },
                });
            }
            !_isError &&
                setTimeout(() => {
                    setShowCamesLoaderState(false);
                }, DELAY);
        }
    };
    const renderEmptyState = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 24 : height }
            ] },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(View, { style: styles.header }, _headerChild),
                React.createElement(View, { style: [{ height: height - 138, justifyContent: 'center', alignItems: 'center' }] },
                    React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Empty_Limit.png" }, style: { width: 250, height: 250 } }),
                    React.createElement(View, { style: {
                            alignItems: 'center',
                            alignContent: 'center',
                            justifyContent: 'center',
                            paddingHorizontal: 50
                        } },
                        React.createElement(Typography, { label: 'You can manage your credit limit, and mark or unmark your funds from here after you start your credit limit', color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20, textAlign: TextAlignTokens.center }))),
                React.createElement(View, { style: styles.footer }, _footerChild()))));
    };
    const _bodyChild = () => {
        return (React.createElement(View, { style: { paddingTop: 24, paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(Typography, { label: isEnhancedLimit ? "Unlock your additional credit limit by pledging your mutual funds" : "Unlock your credit limit by pledging your mutual funds", fontWeight: '700', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, lineHeight: 24 }),
            React.createElement(View, { style: {
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: "#E4E7EC",
                    elevation: Platform.OS === "android" ? 16 : 20,
                    paddingVertical: 16,
                    paddingHorizontal: 20,
                    marginTop: 16,
                    shadowColor: "#98A2B3",
                    backgroundColor: 'white',
                    shadowOffset: {
                        width: 0,
                        height: Platform.OS === "ios" ? 2 : 6,
                    },
                    shadowRadius: 20,
                    shadowOpacity: Platform.OS !== "android" ? 0.2 : 1,
                } },
                React.createElement(View, { style: { flexDirection: "row" } },
                    React.createElement(Image, { source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_icon.png'
                        }, style: { width: 52, height: 52 } }),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: isEnhancedLimit ? "Additional credit limit" : "Credit limit" }),
                        React.createElement(View, { style: { flexDirection: 'row' } },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XL, fontWeight: '700', lineHeight: 32, label: `₹` }),
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XL, fontWeight: '700', lineHeight: 32, label: `${addCommasToNumber(Math.floor(creditLimit))}` })))),
                React.createElement(View, { style: { marginTop: 8 } }),
                React.createElement(Typography, { label: `${Math.floor(completionPercentage)}% unlocked`, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XXS, lineHeight: 16, fontWeight: '400', fontFamily: FontFamilyTokens.Inter }),
                React.createElement(View, { style: { marginTop: 4 } }),
                React.createElement(ProgressIndicator, { activeIndex: 1, size: 1, type: ProgressIndicatorTypeTokens.default, color: ColorTokens.System_Happy, fillPercentage: `${completionPercentage}%`, bgColor: ColorTokens.Secondary_10 }))));
    };
    const handleStartStop = () => {
        setIsRunning((prevIsRunning) => !prevIsRunning);
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                padding: 16,
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    padding: 12,
                    backgroundColor: colorMapping[ColorTokens.Secondary_05],
                    borderRadius: 8
                } },
                React.createElement(Icon, { name: IconTokens.InfoFilled, color: ColorTokens.Secondary_100 }),
                React.createElement(View, { style: { marginLeft: 8 } }, Object.keys(pledgingOrder).length === 1 ? React.createElement(Typography, { label: `We will trigger ${Object.keys(pledgingOrder).length} OTP to unlock your funds`, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: '400' }) :
                    React.createElement(Typography, { label: `We will trigger ${Object.keys(pledgingOrder).length} OTPs to unlock your funds`, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: '400' }))),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { id: 'bt_pledgePortfolio_confirmAndGetOtp', onPress: async () => {
                        handleStartStop();
                        if (elementAtZeroPosition === "CAMS_FETCH") {
                            setShowModal(true);
                            setShowCamesLoaderState(true);
                            if (triggerAction) {
                                await triggerAction(continuePress);
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowCamesLoaderState(false);
                                }, DELAY);
                        }
                        else if (elementAtZeroPosition === "KFIN_FETCH") {
                            setShowModal(true);
                            setShowCamesLoaderState(true);
                            if (triggerAction) {
                                await triggerAction(fetchKarvyAction);
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowCamesLoaderState(false);
                                }, DELAY);
                        }
                        else if (elementAtZeroPosition === "KFIN_PLEDGE") {
                            setShowKarvyModal(true);
                            setShowKarvyLoaderState(true);
                            if (profileAction) {
                                await triggerAction({
                                    ...profileAction,
                                    payload: {
                                        value: "KFIN_PLEDGE",
                                    },
                                });
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowKarvyLoaderState(false);
                                }, DELAY);
                        }
                        else {
                            setShowCamsPledge(true);
                            setShowCamesLoaderState(true);
                            if (profileAction) {
                                await triggerAction({
                                    ...profileAction,
                                    payload: {
                                        value: "CAMS_PLEDGE",
                                    },
                                });
                            }
                            !_isError &&
                                setTimeout(() => {
                                    setShowCamesLoaderState(false);
                                }, DELAY);
                        }
                    }, type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, label: "Confirm & get OTP" })),
            React.createElement(View, { style: {
                    marginTop: 12,
                    borderRadius: 4,
                    borderColor: '#E4E7EC',
                    flexDirection: 'row',
                    borderWidth: 1,
                    width: 250,
                    alignSelf: 'center'
                } },
                React.createElement(View, { style: {
                        borderRightWidth: 1,
                        padding: 8,
                        borderRightColor: '#E4E7EC',
                        justifyContent: 'center'
                    } },
                    React.createElement(Typography, { label: "Powered by", fontSize: FontSizeTokens.XXS, fontWeight: '400', lineHeight: 16, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        borderRightWidth: 1,
                        padding: 8,
                        borderRightColor: '#E4E7EC',
                        justifyContent: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.Kfin, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { padding: 8, borderRightColor: '#E4E7EC', marginTop: 3 } },
                    React.createElement(Icon, { name: IconTokens.Cams, color: ColorTokens.Grey_Charcoal })))));
    };
    const renderMainBody = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 14 : height }
            ] },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(View, { style: styles.header }, _headerChild),
                React.createElement(ScrollView, { style: [{ height: height - 138 }] }, _bodyChild()),
                React.createElement(View, { style: styles.footer }, !showModal && !showKarvyModal && !showCamsPledge && _footerChild())),
            showModal &&
                React.createElement(View, { style: {
                        bottom: 0,
                        position: 'absolute',
                        zIndex: 1
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: showCamsLoaderState ? 466 : showCamsFetchSuccessState ? Platform.OS !== 'web' ? 260 : 246 : 330, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: Platform.OS !== 'web' }, modalContentPresenter())),
            showKarvyModal &&
                React.createElement(View, { style: {
                        bottom: 0,
                        position: 'absolute',
                        zIndex: 1
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: showKarvyLoaderState ? 466 : showKarvyPledgeSuccessState ? Platform.OS !== "web" ? 240 : 226 : 330, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: Platform.OS === 'web' ? false : true }, modalContentPresenterKarvyPledge())),
            showCamsPledge &&
                React.createElement(View, { style: {
                        bottom: 0,
                        position: 'absolute',
                        zIndex: 1
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: showCamsLoaderState ? 466 : showCamsPledgeSuccessState ? Platform.OS !== 'web' ? 260 : 246 : 330, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: Platform.OS === 'web' ? false : true }, modalContentPresenterCamsPledge()))));
    };
    return renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        width: '100%',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
    plainRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    portfoilioDividerStyle: {
        height: 1,
        backgroundColor: '#E4E7EC',
        marginTop: 24,
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
});
export default PledgePorfolio;
